module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-blue.707ce2b4.svg";